import React from 'react';
import LocationCards from '../simple/LocationCards';

export default function LocationsPage({ locations }) {
  return (
    <div className="space-y-6">
      <LocationCards locations={locations} />
    </div>
  );
}
